<template>
  <div class="notfound">
    <h1>Not found</h1>
    <p>Sorry seams like the page doesn't exist, go back to
      <router-link to="/">home</router-link>
    </p>
  </div>
</template>